/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type DescriptionCell_ScheduleFragment = { __typename: 'Schedule', id: string, description: string };

export const DescriptionCell_ScheduleFragmentDoc = gql`
    fragment DescriptionCell_schedule on Schedule {
  id
  description
}
    `;